module.exports = __webpack_public_path__ + "img/bg-login.e74a7e65.png";